/** Active Location Catalog names for pickers: unique, sorted. Excludes inactive entries. */
export function catalogLocationNames(locations) {
  const seen = new Set();
  const out = [];
  for (const loc of locations || []) {
    if (loc?.is_active === false) continue;
    const n = String(loc?.location_name ?? '').trim();
    if (!n || seen.has(n)) continue;
    seen.add(n);
    out.push(n);
  }
  out.sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' }));
  return out;
}
